import { Link, useNavigate } from "react-router";
import { Screen } from "../PodContext";
import "./Header.css";
import ProgressBar from "./ProgressBar";
import Text from "./Text";

const Header = ({
  title,
  progress = 0,
  noBack = false,
  totalSteps = 0,
  backToStart = false,
  hasCabanaLogo = false
}: {
  noBack?: boolean;
  title?: string;
  progress?: number;
  hasCabanaLogo?: boolean;
  totalSteps?: number;
  backToStart?: boolean;
}) => {
  const navigate = useNavigate();

  const goBack = (e: any) => {
    e.preventDefault();
    navigate(-1);
  };

    const goHome = (e: any) => {
    e.preventDefault();
    navigate(Screen.HOME);
  };


  return (
    <>
      {!noBack && (
        <Link className="vr-header-back" to="" onClick={backToStart? goHome : goBack}>
          <img
            src={"/assets/misc/chevron-left.svg"}
            className="vr-header-back-icon"
            alt="arrow"
          />{" "}
          {backToStart ? "Back to Start" : "Back"}
        </Link>
      )}
      <div className="vr-header-container">
        <div className="vr-header-logo">
          <img
            src={
              hasCabanaLogo
                ? "/assets/logos/Cabana_Primary-Horizontal.svg"
                : "/assets/logos/Cabana-Pod.svg"
            }
            alt="Cabana Pod logo"
          />
        </div>
        {!!progress && (
          <ProgressBar totalSteps={totalSteps} currentStep={progress} />
        )}
        <Text type="subtitle" className="text-center">
          {title || ""}
        </Text>
      </div>
    </>
  );
};

export default Header;
